<!-- <div class="flex flex-auto items-center justify-between w-full mb-4">
    <h2 class="text-xl pt-1 font-bold leading-8">
        Search for Company Name or ID
    </h2>
</div> -->

<div class="flex flex-auto items-center justify-between w-full mb-4">
    <h2 class="text-2xl font-bold leading-8">
        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.SEARCH_BY_COMPANY_NAME_TITLE"  | translate }}
    </h2>
</div>

<div class="items-center p-0 mb-3 w-full">

    <div class="items-center">
        <mat-form-field appearance="outline" class="w-6/12 font-normal items-center p-0">
            <!-- <mat-label>
                Search By Foctory name
            </mat-label> -->
            <mat-icon svgIcon="heroicons_outline:search" matPrefix class="pr-1 pb-1"></mat-icon>
    
            <input matInput [(ngModel)]="inputText" minlength="2" class="font-xl font-normal h-auto w-auto " (keyup.enter)="onSupplierSearch()" (input)="checkAndClearList($event)"/>
        </mat-form-field>
    
        <button [disabled]="    inputText == null   || inputText === ''   " 
            type="button" class="ml-3 mb-4 btn btn-primary items-center w-auto" (click)="onSupplierSearch()">
            {{ "BRAND_FACTORY_CONNECTION_COMPONENT.SEARCH_BUTTON" | translate }}

        </button>
    </div>



    <!-- @ Show Results -->
    <div *ngIf="searchDataSource !=null" class="flex flex-auto items-center justify-between w-full">
        <h2 class="text-xl pt-1 font-bold leading-8">
            {{ "BRAND_FACTORY_CONNECTION_COMPONENT.SEARCH_RESULTS_TITLE"  | translate }}
        </h2>
    </div>
    <div *ngIf="searchDataSource !=null" class=" w-full mt-0 pt-0">
        <!-- <hr style="border: 1px solid rgb(176, 174, 174);"> -->
        <table mat-table [dataSource]="searchDataSource" matSort
            class="w-full table table-striped font-normal text-base p-0">
            <!-- Company Name Column -->
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="
                            color: black;
                            font-weight: bold;
                            font-size: 1.05em;
                    ">
                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_COMPANY_NAME"  | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.name }}
                </td>
            </ng-container>


            <!-- Country Name Column -->
            <ng-container matColumnDef="countryName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="
                            color: black;
                            font-weight: bold;
                            font-size: 1.05em;
                    ">
                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_COUNTRY_NAME"  | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.countryName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="
                            color: black;
                            font-weight: bold;
                            font-size: 1.05em;
                    ">
                    Address
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.address }}
                </td>
            </ng-container>

            <!-- Connection Status/Action Column -->
            <ng-container matColumnDef="Connection Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="
                            color: black;
                            font-weight: bold;
                            font-size: 1.05em;
                    ">
                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_ACTION"  | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    <button class="btn btn-primary" *ngIf="row.status == null || row.status == 2 " (click)="sendConnectionRequest(row)">
                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.SEND_REQUEST_BUTTON"  | translate }}
                    </button>

                    <p *ngIf="row.status == 1" style="color: green;">
                        <em>{{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.CONNECTED"  | translate }}</em>
                    </p>
                    <p *ngIf="row.status == 0" style="color: rgb(77, 75, 75);">
                        <em><em>{{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.PENDING"  | translate }}</em></em>
                    </p>
                    <!-- <p *ngIf="row.status == 2" style="color: red">
                        <em>Declined</em>
                    </p> -->
                    
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="searchResultDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: searchResultDisplayedColumns"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_NO_DATA_MATCHING_FILTER"  | translate }}
                </td>
            </tr>
        </table>

        <!-- <mat-paginator #paginatorBrandConn [length]="totalBrandRequestCount" [pageSizeOptions]="[5, 10, 25, 100]"
            (page)="onPageChange($event)" class="pb-2"></mat-paginator> -->
    </div>
</div>